









import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({})
export default class PhoneNumberInput extends Vue {
    @Prop(String) readonly value!: string
    @Prop(String) readonly name!: string
    formatedPhone: string = ''

    mounted() {
        this.formatedPhone = this.formatPhone(this.value)
    }

    handleInput(val) {
        this.formatedPhone = this.formatPhone(val)
        this.$emit('input', this.formatedPhone.replace(/ /g, ''))
    }

    formatPhone(phone: string) {
        if (phone === null) {
            return ''
        }
        const parts = phone.replace(/\D/g, '').match(/\d{1,2}/g)
        return parts === null ? '' : parts.join(' ').substring(0, 14)
    }

    @Watch('value')
    onValueChanged(val: string, oldVal: string) {
        this.formatedPhone = this.formatPhone(this.value)
    }
}
